import React, { useEffect, useState } from "react";
import { fetchData } from "../../../utils/functions"; // Adjust path as needed

// Helper function to format numbers
const formatNumber = (num) => {
  const numValue = typeof num === "string" ? parseInt(num) : num;

  if (numValue === undefined || numValue === null || isNaN(numValue))
    return "0";
  if (numValue >= 1000000) {
    return `${(numValue / 1000000).toFixed(1)}M`;
  } else if (numValue >= 1000) {
    return `${(numValue / 1000).toFixed(1)}K`;
  } else {
    return numValue.toLocaleString();
  }
};

// OutcomesCard component to match the Total Allocated card design
const OutcomesCard = ({ title, value, icon, currency }) => (
  <div className="text-center">
    <div
      className={`rounded-2xl text-white text-xl w-9 h-9 mx-auto my-1 flex items-center justify-center ${
        currency === "€" ? "bg-yellow-600" : "bg-teal-700"
      }`}
    >
      {icon}
    </div>
    <h5 className="text-xs m-0 text-gray-500 font-bold">{title}</h5>
    <h4 className="text-xl m-0 p-0 text-black font-bold text-balance">{value}</h4>
  </div>
);

const TotalYearlyExpenditure = () => {
  const [expenditureData, setExpenditureData] = useState(null);

  useEffect(() => {
    const fetchExpenditureData = async () => {
      try {
        const response = await fetchData("wash-water", "GET");

        if (
          response?.data?.wash_water &&
          Array.isArray(response.data.wash_water)
        ) {
          const totalExpenditure = response.data.wash_water.reduce(
            (sum, item) => {
              const expenditure = parseInt(item.total_yearly_expenditure) || 0;
              return sum + expenditure;
            },
            0
          );

          const totalPeople = response.data.wash_water.reduce((sum, item) => {
            const people = parseInt(item.number_of_people) || 0;
            return sum + people;
          }, 0);

          setExpenditureData({
            total_yearly_expenditure: totalExpenditure,
            number_of_people: totalPeople,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchExpenditureData();
  }, []);

  // Show loading if data is not yet fetched
  if (!expenditureData) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  return (
    <div className="lg:col-span-4">
      {/* Title */}
      <div className="text-center mb-3">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-balance">
          Total Yearly Expenditure
        </h3>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-2 gap-4 mt-3">
        <OutcomesCard
          title="Total Yearly Expenditure (PKR)"
          value={`₨ ${formatNumber(expenditureData?.total_yearly_expenditure)}`}
          icon="₨"
          currency="₨"
        />
        <OutcomesCard
          title="Number of People"
          value={formatNumber(expenditureData?.number_of_people)}
          icon="👥"
          currency=""
        />
      </div>
    </div>
  );
};

export default TotalYearlyExpenditure;
